import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Principal } from 'src/app/core/auth/principal.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiStaffAuthorityScope="'brokerManagement'">...</some-element>
 *
 *     <some-element *jhiStaffAuthorityScope="['brokerManagement', 'userManagement']">...</some-element>
 * ```
 */
@Directive({
    selector: '[jhiStaffAuthorityScope]'
})
export class StaffAuthorityDirectiveForScope {
    private authorities: string[];

    constructor(private principal: Principal, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

    @Input()
    set jhiStaffAuthorityScope(value: string | string[]) {
        this.authorities = typeof value === 'string' ? [value] : value;
        this.updateView();
    }

    private updateView(): void {
        if(this.principal.hasStaffPermissionWithOutPromise(this.authorities[0])){
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }else{
            this.viewContainerRef.clear();
        }
    }
}
